import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";

interface ThemeToggleProps {
  transparent?: boolean;
}

export const ThemeToggle = ({ transparent = false }: ThemeToggleProps) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`p-1.5 sm:p-2 rounded-full hover:bg-white/10 transition-all ${
        transparent ? "text-white" : "hover:bg-muted/60"
      }`}
      aria-label="Toggle theme"
    >
      {isDark ? (
        <Sun className="h-4 w-4 sm:h-5 sm:w-5" />
      ) : (
        <Moon className="h-4 w-4 sm:h-5 sm:w-5" />
      )}
    </button>
  );
};
